import React, { PropsWithChildren } from 'react';
import {useAsync} from "react-async-hook";
import { Sidebar } from '../../pages/common/admin/sidebar/Sidebar';
import {Header} from "../../pages/common/admin/Header";
import {config} from "../../../libs/config/config";

export const AdminDefaultLayout: React.FC = (props: PropsWithChildren<any>) => {
  const {children} = props;

  useAsync(
    async () => {
      document.title = config.app.room.name;
    },
    []);

  return (
    <>
      <div className="flex min-h-screen min-w-screen m-0">

        {/* サイドバー */}
        <Sidebar />

        <div className="flex flex-col flex-grow">
          {/* ヘッダー */}
          <Header />
          {/* コンテンツ */}
          <main className="flex-grow">
            {children}
          </main>
        </div>
      </div>
    </>
  );
};